module.exports = __webpack_public_path__ + "static/media/pic-light.82f1c499.svg";